/**
 * z-index 레이어 상수
 * 모달, 다이얼로그, 오버레이 등의 레이어 우선순위를 관리
 */
export const LAYER = {
  /** 기본 페이지 콘텐츠 */
  BASE: 0,
  /** 모바일 채팅 오버레이 */
  MOBILE_CHAT: 40,
  /** 다이얼로그 및 모달 (TTS Dialog, Rename Dialog 등) */
  DIALOG: 130,
} as const;
